import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { useAppDispatch } from "src/hooks/redux";
import { doneDealAsync } from "src/redux/currentDeal/actions";
import { getDealInitiator } from "src/page-components/cabinet/deals/constants";
import { SingleButtonSelector } from "src/components/ButtonSelector/SingleButtonSelector";
import { ButtonChat } from "src/components/ButtonChat";
import { Button } from "src/components/Button";
import { ButtonDownload } from "src/components/ButtonDownload";
import { ButtonVariants } from "src/components/Button/types";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { IDeal } from "src/@types/deals";
import { ISelectOption } from "src/@types/form";
import { ReactComponent as SuccessIcon } from "src/assets/icons/success.svg";
import { ApprovedDealRequestHead } from "./ApprovedDealRequestHead";
import { DealInfo } from "./DealInfo";
import { approvedDealTrns } from "../trns";

export const ApprovedDealRequest: FC<IDeal> = ({
  id,
  inquiry,
  clone,
  seller,
  buyer,
  chat,
}) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const isPhone = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.MD,
  });

  const Signatorys: ISelectOption[] = [
    {
      id: "1",
      value: seller.user,
      label: "Seller",
    },
    {
      id: "2",
      value: buyer.user,
      label: "Buyer",
    },
  ];

  const [selectedSignatory, setSelectedSignatory] = useState<ISelectOption>(
    Signatorys[0]
  );

  const visibleSignatory =
    seller.user === selectedSignatory.value ? seller : buyer;

  const handleDownload = () => {};

  const onFinish = () => {
    dispatch(doneDealAsync(id));
  };

  return (
    <div className="flex flex-col gap-2 w-full rounded-20">
      <ApprovedDealRequestHead
        chatId={chat}
        {...getDealInitiator(inquiry, clone)}
      />

      <ButtonChat className="block lg:hidden" chatId={chat} isActiveStatus />

      {isPhone ? (
        <>
          <SingleButtonSelector
            activeOption={selectedSignatory.value}
            setActiveOption={setSelectedSignatory}
            options={Signatorys}
          />
          <DealInfo {...visibleSignatory} />
        </>
      ) : (
        <div className="flex gap-2">
          <DealInfo {...seller} />
          <DealInfo {...buyer} />
        </div>
      )}

      <ButtonDownload
        variant={ButtonVariants.SECONDARY}
        onClick={handleDownload}
      >
        {t(approvedDealTrns.exportButton)}
      </ButtonDownload>

      <Button
        className="flex gap-2.5 py-4"
        variant={ButtonVariants.PRIMARY}
        onClick={onFinish}
      >
        <SuccessIcon className="fill-svg-white-base" />
        {t(approvedDealTrns.completeButton)}
      </Button>
    </div>
  );
};
